export enum ExternalIntegrationStatus {
  NOT_CONNECTED = 'not_connected',
  PENDING = 'pending',
  CONNECTED = 'connected',
  CUSTOMER_FIELD_MATCHED = 'customer_field_matched',
  LIST_CHOSEN = 'list_chosen',
  ACTIVE = 'active',
  DISCONNECTED = 'disconnected',
  ERROR = 'error',
  UNAUTHORIZED = 'unauthorized',
}
